"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { trackEvent } from "@/lib/analytics";

export default function HipaaComplianceBadge() {
  const pathname = usePathname();

  const handleClick = () => {
    trackEvent("footer_link_click", {
      link: "hipaa_compliance",
      page: pathname,
    });
  };

  return (
    <Link
      href="/hipaa-compliance"
      onClick={handleClick}
      aria-label="HIPAA compliance details"
      data-ph-capture="true"
      data-ph-capture-attribute-link="hipaa_compliance"
      className="group inline-flex items-center rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
    >
      <Image
        src="/hipaa-compliant-badge.avif"
        alt=""
        width={326}
        height={177}
        className="h-12 w-auto brightness-0 invert opacity-70 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity"
      />
    </Link>
  );
}
